module.exports = __webpack_public_path__ + "static/media/workflux-login.2c136521.svg";